<template src="./embedded-submission.html"></template>

<script lang="ts">
import domUtils from 'util/dom-utils'
import embeddedSubmissionConfig from './embedded-submission.config'
import globalConfig from 'init/global.config'
import { hostsConfig } from 'init/config'
import Popover from 'objects/popover/Popover.vue'
import submissionStore from 'store/submission-store'
import SubmissionMediator from './SubmissionMediator.vue'


export default {
  name: 'EmbeddedSubmission',
  data() {
    return {
      isFormLoaded: false,
      submissionStore
    }
  },
  components: {
    'tt-popover': Popover,
    'tt-submission-mediator': SubmissionMediator
  },
  computed: {
    header() {
      const imgName = embeddedSubmissionConfig.headerImage
      if (embeddedSubmissionConfig.turntoHosted && imgName) {
        return {
          imgUrl: imgName ? `https://${hostsConfig.imageStoreBase}/site/${imgName}` : '',
          siteName: globalConfig.siteName,
          siteLink: embeddedSubmissionConfig.siteLink
        }
      }
      return null
    },
    isOpen() {
      return this.submissionStore.isOpen
    },
    poweredByText() {
      return this.submissionStore.poweredByText
    }
  },
  methods: {
    closePopover() {
      this.popoverMessage = ''
    },
    closeEmbeddedSubmission() {
      submissionStore.fireBackEvent()
    },
    pageLoaded() {
      this.isFormLoaded = true
    },
    pageLoading() {
      this.isFormLoaded = false
      // while loading, scroll to the top and focus on the container.  The component being loaded
      // will decide if focus should go elsewhere
      domUtils.scrollToTop()
      domUtils.safeFocus(() => this.$el)
    },
    onShowError(providedMessage, closeModal = false, autoClosePopup = true) {
      const message = providedMessage || this.$msg('flowError.2000')
      import(/* webpackChunkName: 'standalone-popover' */ 'widgets/standalone-popover/standalone-popover-loader').then((popoverLoader) => {
        popoverLoader.default.load({ message, type: 'error' , autoClose: autoClosePopup })
      })
      // in this case, it's not modal like it is in submisson-modal, but same idea, remove the form
      if (closeModal) {
        this.closeEmbeddedSubmission()
      }
    },
    onShowPopoverMessage(message, closeModal = false) {
      import(/* webpackChunkName: 'standalone-popover' */ 'widgets/standalone-popover/standalone-popover-loader').then((popoverLoader) => {
        popoverLoader.default.load({ message, type: 'success' })
      })
      // in this case, it's not modal like it is in submisson-modal, but same idea, remove the form
      if (closeModal) {
        this.closeEmbeddedSubmission()
      }
    }
  }
}
</script>

<style lang="scss" src="./embedded-submission.scss"></style>
